import * as Sentry from '@sentry/react'

import { assertExists } from '~/utils'

if (process.env.IS_PRODUCTION) {
  Sentry.init({
    dsn: 'https://7230000c8f1943f99c79bca1969ac213@o527506.ingest.sentry.io/5673139',
    release: `9segs-integration-spa@${process.env.NPM_PACKAGE_VERSION}`,
    integrations: [Sentry.browserTracingIntegration()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  })
}

export const container = document.getElementById('main')
assertExists(container)
